import { type Injector } from '@angular/core';
import { BaseWidget } from '@sds/widget-gridster';

export class UserDateTimeWidget extends BaseWidget<never> {
  static readonly id = 'user-date-time';
  static readonly publicFriendly = false;

  static factory(injector: Injector, metaLinkId: string, x: number, y: number, rows: number, cols: number) {
    return new UserDateTimeWidget(injector, metaLinkId, x, y, rows, cols);
  }

  constructor(injector: Injector, metaLinkId: string, x: number, y: number, rows: number, cols: number) {
    super(injector, UserDateTimeWidget.id, UserDateTimeWidget.publicFriendly, metaLinkId, x, y, rows, cols);
    this.resolveComponent(async () => {
      const module = await import('./user-date-time/user-date-time.component');
      return Object.values(module)[0];
    });
  }
}
